import { render, staticRenderFns } from "./couponOrderList.vue?vue&type=template&id=2367ba97&scoped=true"
import script from "./couponOrderList.vue?vue&type=script&lang=js"
export * from "./couponOrderList.vue?vue&type=script&lang=js"
import style0 from "./couponOrderList.vue?vue&type=style&index=0&id=2367ba97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2367ba97",
  null
  
)

export default component.exports